import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=87954210&scoped=true"
import script from "./cashier.vue?vue&type=script&lang=ts"
export * from "./cashier.vue?vue&type=script&lang=ts"
import style0 from "./cashier.vue?vue&type=style&index=0&id=87954210&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87954210",
  null
  
)

export default component.exports